module.exports = __webpack_public_path__ + "img/checked-traning-icon.90353f51.svg";